import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-purple',
    templateUrl: './purple.component.html',
    styleUrls: ['./purple.component.scss']
})
export class PurpleComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public authenticationService: AuthenticationService,
        public dialogRef: MatDialogRef<PurpleComponent>,
    ) {
    }

    ngOnInit(): void {
    }

    onYesClick() {
        this.dialogRef.close();
    }
}
